import React from 'react'

import { useLocation, useNavigate } from 'react-router-dom';
import axios from "axios";
import queryString from 'query-string';
import Swal from 'sweetalert2'

import ReactLoading from 'react-loading';
import config from "../../config"

import { useNetworkState } from 'react-use';
import Footer from './Footer';
import Header from './Header';


const Rate_calculator = () => {



  const [dimensionState, setdimensionState] = React.useState({ companyDetail: [] })

  const [parceltype, setparceltypeState] = React.useState({ parcel: true })
  const [documenttype, setdocumenttypeState] = React.useState({ document: false })
  const [state, setState] = React.useState({ parcel_type: "Parcel", from_postal_code: "", to_postal_code: "", mode: "Domestic", weight: "", length: "", width: "", height: "", country_name: "", shipment_value: "" })
  // console.log("state === " , state)
  const [active, setactive] = React.useState(1)
  const [statepackage, setStatepackage] = React.useState([]);
  const [loadingstate, setLoadingstate] = React.useState({ loading: false })
  const [errorstate, seterrorstate] = React.useState({ message: "" })
  const [paymentmode, setpaymentmode] = React.useState({ mode: 1 })
  const [codvalue, setcodvalue] = React.useState({ cod_amount: 0, err: {} })
  const [volume, setVolume] = React.useState()
  const [countryList, setcountryList] = React.useState([]);
  const [volstate, setVolstate] = React.useState(null)
  const [data, setData] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState("");
  const [riskstate, setriskstate] = React.useState({ risk: 2 })
  const [showBreakdown, setShowBreakdown] = React.useState(false);
  const [selfstate, setselfstate] = React.useState({
    self: 1
  });
  const [boxDetails, setBoxDetails] = React.useState(
    [{
      box_name: '',
      box_length: '',
      box_width: '',
      box_height: '',
      box_weight: '',
      quantity: ''
    }]
  );
  const [boxErrors, setBoxErrors] = React.useState([]);
  let userDetail = localStorage.getItem('ship_rocket_user');
  // console.log("userDetail====", config.UserId);
  let userData = {};
  if (userDetail != null) {
    userData = JSON.parse(userDetail)
  }

  React.useEffect(() => {
    getCountryList()
  }, [])

  const handleChange = (e) => {
    console.log("namess", e.target.name)
    console.log("value", e.target.value)
    console.log("type", e.target.type)


    let names = e.target.name
    let value = e.target.value

    if (e.target.type == "text") {
      setState({ ...state, [e.target.name]: value })
    }
    else if (e.target.type == "select-one") {
      setState({ ...state, [e.target.name]: value })
    }
    else if (e.target.type == "radio") {
      if (e.target.checked == true) {

        if (e.target.name == "document") {
          setparceltypeState({ ...parceltype, parcel: false })
          setdocumenttypeState({ ...documenttype, document: true })
          setState({ ...state, parcel_type: "Document" })
        }
        else {
          setparceltypeState({ ...parceltype, parcel: true })
          setdocumenttypeState({ ...documenttype, document: false })
          setState({ ...state, parcel_type: "Parcel" })
        }
      }
    }
    else if (e.target.type == "number") {
      setState({ ...state, [e.target.name]: value })
    }
    else if (e.target.type == "date") {
      setState({ ...state, [e.target.name]: value })

    }
  }


  const changebar = () => {
    setactive(1)
    setState({ ...state, mode: "Domestic", parcel_type: "Parcel", from_postal_code: "", to_postal_code: "", weight: "", length: "", width: "", height: "", country_name: "" })
    setStatepackage([])
  }
  const changebar1 = () => {
    setactive(0)
    setState({ ...state, mode: "Domestic", parcel_type: "Parcel", from_postal_code: "", to_postal_code: "", weight: "", length: "", width: "", height: "", country_name: "" })
    setStatepackage([])
  }


  const get_list = async (sortValue) => {
    setLoadingstate({ ...loadingstate, loading: true })
    if (state.from_postal_code != "" && state.to_postal_code != "" && state.mode != "" && state.parcel_type != "" && state.weight != "" && state.height != "" && state.width != "" && state.length != "") {
      if (paymentmode.mode == 1 || paymentmode.mode == 2 && codvalue.cod_amount != "") {

        let sort = "default";
        if (sortValue) {
          sort = sortValue
        }
        let dataToSend = {
          customer_id: userData.customer_id,
          from_postal_code: state.from_postal_code,
          to_postal_code: state.to_postal_code,
          weight: volume && state.weight != "" ? parseFloat(volume) > parseFloat(state.weight) ? volume : state.weight : 0.00,
          length: state.length,
          height: state.height,
          width: state.width,
          //  sort_by:sort ,
          parcel_type: state.parcel_type,
          mode: state.mode,
          payment_mode: paymentmode.mode == 2 ? "cod" : "prepaid",
          order_amount: codvalue.cod_amount,
          carrier_type: 1,

          from_country_code: "IN",


          to_country_code: "IN"
         

        };

        // console.log("datatoSend",dataToSend)
        let url = config.apiUrl + '/shipment/shipment_rate_time';

        // // console.log("headers => ", config.headers);


        axios.post(url, dataToSend, { headers: config.headers })
          .then((responseJson) => {
            // console.log("responseJson => ", responseJson.data);
            setLoadingstate({ ...loadingstate, loading: false })
            if (responseJson.data.status == "success") {
              setStatepackage(responseJson.data.output)
              if (responseJson.data.output.length == 0) {
                seterrorstate({ ...errorstate, message: "No services available for the selected route and package combination." })
              }
            }

            else {

              const Toast = Swal.mixin({
                toast: true,
                position: 'bottom-end',
                showConfirmButton: false,
                timer: 3000
              })
              Toast.fire({
                background: "#a61c09",
                type: 'Unsuccess',
                title: responseJson.data.message,
                color: "white"
              });
            }

          })
          .catch((error) => {
            //Hide Loader
            setLoadingstate({ ...loadingstate, loading: false })
            // console.log(error);
          });
      }
      else {
        const Toast = Swal.mixin({
          toast: true,
          position: 'bottom-end',
          showConfirmButton: false,
          timer: 3000
        })

        Toast.fire({
          background: "#a61c09",
          type: 'unsuccess',
          title: "Please enter cod value",
          color: "white"
        });
        setLoadingstate({ ...loadingstate, loading: false })

      }
    }
    else {
      const Toast = Swal.mixin({
        toast: true,
        position: 'bottom-end',
        showConfirmButton: false,
        timer: 3000
      })
      Toast.fire({
        background: "#a61c09",
        type: 'Unsuccess',
        title: "Please Fill All the Fields",
        color: "white"
      });
      setLoadingstate({ ...loadingstate, loading: false })

    }
  };

  const get_b2b_list = async (sortValue) => {
    const newBoxErrors = [];
    boxDetails.forEach((box, index) => {
      const errors = {};
      if (!box.box_length) errors.box_length = 'Length is required';
      if (!box.box_width) errors.box_width = 'Width is required';
      if (!box.box_height) errors.box_height = 'Height is required';
      if (!box.box_weight) errors.box_weight = 'Weight is required';
      if (!box.quantity) errors.quantity = 'Quantity is required';
      // if (!box.product_name) errors.product_name = 'Product Name is required';
      // if (!box.unit_price) errors.unit_price = 'Unit price is required';
      newBoxErrors[index] = errors;
    });
    setBoxErrors(newBoxErrors);

    if (newBoxErrors.some(errors => Object.keys(errors).length > 0)) {
      return;
    }
    setLoadingstate({ ...loadingstate, loading: true })
    if (state.from_postal_code != "" && state.to_postal_code != "" && state.mode != "" && state.parcel_type != "" && state.shipment_value != "") {
      if (paymentmode.mode == 1 || paymentmode.mode == 2 && codvalue.cod_amount != "") {

        let sort = "default";
        if (sortValue) {
          sort = sortValue
        }
        let dataToSend = {
          customer_id: userData.customer_id,
          from_postal_code: state.from_postal_code,
          to_postal_code: state.to_postal_code,
          weight: boxDetails.reduce((sum, box) => {
            return Number(sum) + Number(box.box_weight);
          }, 0),
          length: state.length,
          height: state.height,
          width: state.width,
          shipment_value: state.shipment_value,
          insurance: riskstate.risk,
          //  sort_by:sort ,
          parcel_type: state.parcel_type,
          mode: state.mode,
          payment_mode: paymentmode.mode == 2 ? "cod" : "prepaid",
          order_amount: codvalue.cod_amount,
          carrier_type: 2,

          from_country_code: "IN",

          boxes: boxDetails,
          to_country_code: "IN",
          self: selfstate.self

        };

        // console.log("datatoSend",dataToSend)
        let url = config.apiUrl + '/shipment/b2b_shipment_rate_time';

        // // console.log("headers => ", config.headers);


        axios.post(url, dataToSend, { headers: config.headers })
          .then((responseJson) => {
            // console.log("responseJson => ", responseJson.data);
            setLoadingstate({ ...loadingstate, loading: false })
            if (responseJson.data.status == "success") {
              setStatepackage(responseJson.data.output)
              if (responseJson.data.output.length == 0) {
                seterrorstate({ ...errorstate, message: "No services available for the selected route and package combination." })
              }
            }

            else {

              const Toast = Swal.mixin({
                toast: true,
                position: 'bottom-end',
                showConfirmButton: false,
                timer: 3000
              })
              Toast.fire({
                background: "#a61c09",
                type: 'Unsuccess',
                title: responseJson.data.message,
                color: "white"
              });
            }

          })
          .catch((error) => {
            //Hide Loader
            setLoadingstate({ ...loadingstate, loading: false })
            // console.log(error);
          });
      }
      else {
        const Toast = Swal.mixin({
          toast: true,
          position: 'bottom-end',
          showConfirmButton: false,
          timer: 3000
        })

        Toast.fire({
          background: "#a61c09",
          type: 'unsuccess',
          title: "Please enter cod value",
          color: "white"
        });
        setLoadingstate({ ...loadingstate, loading: false })

      }
    }
    else {
      const Toast = Swal.mixin({
        toast: true,
        position: 'bottom-end',
        showConfirmButton: false,
        timer: 3000
      })
      Toast.fire({
        background: "#a61c09",
        type: 'Unsuccess',
        title: "Please Fill All the Fields",
        color: "white"
      });
      setLoadingstate({ ...loadingstate, loading: false })

    }
  };


  // const sort_by = (e) =>{
  // // console.log(e.target.value);
  // get_list(e.target.value)
  // }
  React.useEffect(() => {
    // if(apiFlag){
    //   apiFlag = false;
    // get_list()  
    vol_status_function()
    dimension_detail()
    // }
  }, [])
  const dimension_detail = () => {
    let full_api = config.apiUrl + `/user/get_company_info_api`;
    let sendData = {};

    axios.post(full_api, sendData, { headers: config.headers }).then(res => {
      setdimensionState({ ...dimensionState, companyDetail: res.data.companyDetail });
      // console.log("rnmmmmm", res);
    }).catch((e) => {
      // toast.configure()
      //toast.error("Some thing went wrong")
      // console.log("----error:   ", e);
    })
  }

  const reset = () => {
    setState({ ...state, parcel_type: "Parcel", from_postal_code: "", to_postal_code: "", mode: active == 0 ? "Domestic" : "International", weight: "", length: "", width: "", height: "", country_name: "", shipment_value: "" })
    setdocumenttypeState({ ...documenttype, document: false })
    setparceltypeState({ ...parceltype, parcel: true })
    setcodvalue({ ...codvalue, cod_amount: 0, err: {} })
  }
  const payment_mode = (e) => {
    if (e.target.name == "prepaid") {
      setpaymentmode({ mode: 1 })
    }
    else {
      setpaymentmode({ mode: 2 })
    }
  }
  const codvalueChange = (e) => {

    setcodvalue({ ...codvalue, cod_amount: e.target.value, err: {} })
  }
  const vol_status_function = () => {
    let full_api = config.apiUrl + `/user/customer_volumetric_status`;
    let sendData = {};

    axios.post(full_api, sendData, { headers: config.headers }).then(res => {
      setVolstate(res.data.volumetric_status);
      // console.log("rnmmmmm", res);
    }).catch((e) => {
      // toast.configure()
      //toast.error("Some thing went wrong")
      // console.log("----error:   ", e);
    })
  }

  React.useEffect(() => {
    if (state.height !== "" && state.width !== "" && state.length !== "") {
      let divisor = volstate === 1 ? 5000 : 1;
      const calculatedVolume = (state.height * state.width * state.length) / divisor;
      setVolume(calculatedVolume.toFixed(2));
    } else {
      setVolume(0);
    }
  }, [state.height, state.width, state.length, volstate]);

  const getCountryList = () => {


    let url = config.apiUrl + '/country/country_list_international';
    let sendData = { limit: 300, status: 1 };
    // console.log("bb", sendData);
    axios.post(url, sendData, { headers: config.headers }).then((res) => {
      // console.log("res ", res);           
      setcountryList(res.data.output)


    }).catch((e) => {


    });
  }

  React.useEffect(() => {
    // Fetch data from the backend
    const fetchData = async () => {
      try {
        const response = await axios.post(config.apiUrl + '/shipment/getPricingData', { headers: config.headers });
        if (response.data.success) {
          setData(response.data.data);
        } else {
          setError("Failed to fetch data");
        }
      } catch (err) {
        console.error(err);
        setError("An error occurred while fetching data");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const risk_mode = (e) => {
    if (e.target.name == "owner_risk") {
      setriskstate({ risk: 1 })
    }
    else {
      setriskstate({ risk: 2 })
    }
  }
  const self_mode = (e) => {
    if (e.target.name == "self_pickup") {
      setselfstate({ self: 1 })
    }
    else {
      setselfstate({ self: 2 })
    }
  }

  const handleAddBox = () => {
    setBoxDetails([
      ...boxDetails,
      {
        box_length: '',
        box_width: '',
        box_height: '',
        box_weight: '',
        quantity: '',
      },
    ]);
  };
  const handleRemoveBox = (indexToRemove) => {
    const updatedBoxes = boxDetails.filter((_, index) => index !== indexToRemove);
    setBoxDetails(updatedBoxes);
  };
  const handleBoxDimensionChange = (event, key, index) => {

    const value = key === 'quantity' || key === 'unit_price' ? parseFloat(event.target.value) : event.target.value;
    setBoxDetails(prevState => {
      const newState = [...prevState];
      newState[index][key] = value;
      return newState;
    });
  };
  return (
    <div>
      <Header />
      <div class="page-wrapper pinned">
        <div class="main-container">
          <div className='app-container'>
            <div class="app-body">
              <div class="container-fluid">

                <div class="mob_nav">
                  <div class=" d-flex justify-content-start ">
                    <a href="javascript:window.history.back();" class=""><i class="bi bi-arrow-left"></i></a>
                    <h2>Shipping Rate Calculator</h2>
                  </div>
                </div>


                <div class="row justify-content-between">
                  <div class="col-12 col-md-4 desk_nav">
                    <div class="d-flex">
                      <a href="javascript:window.history.back();" class="back_btn"><i class="bi bi-arrow-90deg-left"></i></a>
                      <h2>Shipping Rate Calculator</h2>
                    </div>
                  </div>
                </div>
                <section class="mb-3 mt-3 tools">
                  <div class="">

                    <ul class="nav nav-pills">
                      {/* <li class="nav-item">
                        <a class={active == 0 ? "nav-link active" : "nav-link"} style={{ cursor: "pointer" }} onClick={() => changebar1()}>B2C</a>
                      </li> */}
                      <li class="nav-item">
                        <a class={active == 1 ? "nav-link active" : "nav-link"} style={{ cursor: "pointer" }} onClick={() => changebar()}>B2B</a>
                      </li>
                    </ul>

                    <div class="row py-3">
                      {active == 0 ?
                        <div class="col-12 col-md-8">
                          <div class="card border-0 order_box shadow-sm">
                            <div class="card-body">
                              <section class="pb-5">
                                <div class="row">
                                  {/* <div class="col-12 col-md-12 mb-3">
                                        <label for="" class="form-label">Shipment Type:</label>
                                        <div>
                                            <div class="form-check form-check-inline">
                                            <input class="form-check-input" type="radio"  onChange={(e)=>handleChange(e)} name="document" id="inlxineRadio1"  checked={documenttype.document==true && parceltype.parcel==false}/>
                                              <label class="form-check-label" for="inlineRadio1">Document</label>
                                            </div>
                                            <div class="form-check form-check-inline">
                                            <input class="form-check-input" type="radio" name="parcel" onChange={(e)=>handleChange(e)} id="inlixneRadio2" value={state.parcel_type} checked={parceltype.parcel==true && documenttype.document==false }/>
                                              <label class="form-check-label" for="inlineRadio2">Parcel</label>
                                            </div>
                                        </div>
                                    </div> */}
                                  <div class="col-12 col-md-6 mb-3">
                                    <label for="" class="form-label">Pickup Pincode:</label>
                                    <input type="text" class="form-control" id="" placeholder="Enter pickup pincode" name="from_postal_code" value={state.from_postal_code} onChange={(e) => handleChange(e)} />
                                  </div>
                                  <div class="col-12 col-md-6 mb-3">
                                    <label for="" class="form-label">Delivery Pincode:</label>
                                    <input type="text" class="form-control" id="" placeholder="Enter delivery pincode" name="to_postal_code" value={state.to_postal_code} onChange={(e) => handleChange(e)} />
                                  </div>
                                  <div class="col-12 col-md-6 mb-3">
                                    <label for="" class="form-label">Actual Weight:</label>
                                    <div class="input-group">
                                      <input type="text" class="form-control" placeholder="Enter Weight" name="weight" onChange={(e) => handleChange(e)} value={state.weight} />
                                      <span class="input-group-text">KG</span>
                                    </div>
                                  </div>
                                  <div class="col-12 col-md-6 mb-3">
                                    <label for="" class="form-label">Dimensions:</label>
                                    <div class="row">
                                      <div class="col-12 col-md-4 mb-3">
                                        <div class="input-group">
                                          <input type="text" class="form-control" placeholder="H" onChange={(e) => handleChange(e)} name="height" value={state.height} />
                                          <span class="input-group-text">CM</span>
                                        </div>
                                      </div>
                                      <div class="col-12 col-md-4 mb-3">
                                        <div class="input-group">
                                          <input type="text" class="form-control" placeholder="W" onChange={(e) => handleChange(e)} name="width" value={state.width} />
                                          <span class="input-group-text">CM</span>
                                        </div>
                                      </div>
                                      <div class="col-12 col-md-4 mb-3">
                                        <div class="input-group">
                                          <input type="text" class="form-control" placeholder="L" onChange={(e) => handleChange(e)} name="length" value={state.length} />
                                          <span class="input-group-text">CM</span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col-12 col-md-6 mb-3">
                                    <label for="" class="form-label">Mode:</label>
                                    <div>
                                      <div class="form-check form-check-inline">
                                        <input class="form-check-input" type="radio" name="cod" id="inlineRadio2" value="option2" onChange={(e) => payment_mode(e)} checked={paymentmode.mode == 2} />
                                        <label class="form-check-label" for="inlineRadio1">Cash On Delivery</label>
                                      </div>
                                      <div class="form-check form-check-inline">
                                        <input class="form-check-input" type="radio" name="prepaid" id="inlineRadio1" value="option1" onChange={(e) => payment_mode(e)} checked={paymentmode.mode == 1} />
                                        <label class="form-check-label" for="inlineRadio2">Prepaid</label>
                                      </div>
                                    </div>
                                  </div>
                                  {paymentmode.mode == 2 ?
                                    <div class="row">
                                      <div class="col-12 col-md-5 mb-3">
                                        <input type="text" class="form-control" id="" placeholder="Enter COD amount" name="cod_amount"
                                          onChange={(e) => codvalueChange(e)} value={codvalue.cod_amount} />
                                      </div>
                                    </div> : ""}
                                  {/* <div class="col-12 col-md-6 mb-3">
                                        <label for="" class="form-label">Shipment Value (₹):</label>
                                        <div class="input-group">
                                            <span class="input-group-text">₹</span>
                                            <input type="text" class="form-control" placeholder="Enter the shipment values" value="0.00" />
                                        </div>
                                    </div> */}
                                  {/* <div class="col-12 col-md-6 mb-3">
                                        <label for="" class="form-label">Shipping Dangerous Goods?:</label>
                                        <div>
                                            <div class="form-check form-check-inline">
                                              <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio1" value="option1" />
                                              <label class="form-check-label" for="inlineRadio1">Yes</label>
                                            </div>
                                            <div class="form-check form-check-inline">
                                              <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio2" value="option2" />
                                              <label class="form-check-label" for="inlineRadio2">No</label>
                                            </div>
                                        </div>
                                    </div> */}
                                </div>
                                <h6>Volumetric Weight <span class="ms-5">{volume} Kg</span></h6>

                                <h6 class="mb-3 mt-3">Applicable Weight  <span className='ms-5'>{volume && state.weight !== "" ?
                                  (parseFloat(volume) > parseFloat(state.weight) ? volume : state.weight) + " Kg" :
                                  "0.00 Kg"
                                }</span> </h6>
                                <div>
                                  <a onClick={() => get_list()} class="btn btn-primary">Calculate</a>
                                  <a onClick={() => reset()} class="btn btn-outline-primary">Reset</a>
                                </div>
                              </section>
                            </div>
                          </div>
                        </div>
                        :
                        <div class="col-12 col-md-10">
                          <div class="card border-0 order_box shadow-sm">
                            <div class="card-body">
                              <section class="pb-5">
                                <div class="row">

                                  <div class="col-12 col-md-6 mb-3">
                                    <label for="" class="form-label">Pickup Pincode:</label>
                                    <input type="text" class="form-control" id="" placeholder="Enter pickup pincode" name="from_postal_code" value={state.from_postal_code} onChange={(e) => handleChange(e)} />
                                  </div>
                                  <div class="col-12 col-md-6 mb-3">
                                    <label for="" class="form-label">Delivery Pincode:</label>
                                    <input type="text" class="form-control" id="" placeholder="Enter delivery pincode" name="to_postal_code" value={state.to_postal_code} onChange={(e) => handleChange(e)} />
                                  </div>
                                  {boxDetails.map((box, index) => (
                                    <div class="card mb-2" key={index} >
                                      <div class="card-body">
                                        <section class="">
                                          <h6 class="mb-4">Box {index + 1} Detail</h6>
                                          <div class="row">

                                            <div class="col-12 col-md">
                                              <label for="" class="form-label">Box Dimensions (CM):</label>
                                              <div class="row g-1">
                                                <div class="col-12 col-md mb-2">
                                                  <input type="number" className="form-control" id="" placeholder="Length" value={box.box_length} onChange={(e) => handleBoxDimensionChange(e, 'box_length', index)} />
                                                  <span>{boxErrors[index]?.box_length}</span>
                                                </div>
                                                <div class="col-12 col-md mb-2">
                                                  <input type="number" class="form-control" id="" placeholder="Width" name="" value={box.box_width} onChange={(e) => handleBoxDimensionChange(e, 'box_width', index)} />
                                                  <span>{boxErrors[index]?.box_width}</span>
                                                </div>
                                                <div class="col-12 col-md mb-2">
                                                  <input type="number" class="form-control" id="" placeholder="Height" name="" value={box.box_height} onChange={(e) => handleBoxDimensionChange(e, 'box_height', index)} />
                                                  <span>{boxErrors[index]?.box_height}</span>
                                                </div>
                                              </div>
                                            </div>
                                            <div class="col-12 col-md-2">
                                              <label for="" class="form-label">Box Weight(KG):</label>
                                              <input type="number" class="form-control" id="" placeholder="Enter Weight" name="" value={box.box_weight} onChange={(e) => handleBoxDimensionChange(e, 'box_weight', index)} />
                                              <span>{boxErrors[index]?.box_weight}</span>
                                            </div>
                                            <div class="col-12 col-md-2">
                                              <label for="" class="form-label">Box Quantity:</label>
                                              <input type="number" class="form-control" id="" placeholder="Enter quantity" name="" value={box.quantity} onChange={(e) => handleBoxDimensionChange(e, 'quantity', index)} />
                                              <span>{boxErrors[index]?.quantity}</span>
                                            </div>
                                          </div>
                                        </section>
                                        <section class="pb-3">
                                          <div class="row">

                                            <div class="col-12 col-md-2 mb-3">
                                              {index === 0 ? (
                                                <>
                                                  <button
                                                    type="button"
                                                    className="btn btn-success btn-sm"
                                                    style={{ marginTop: "30px" }}
                                                    onClick={handleAddBox}
                                                  >
                                                    Add Box
                                                  </button>
                                                </>) : (
                                                <button
                                                  type="button"
                                                  className="btn btn-danger btn-sm"
                                                  style={{ marginTop: "30px" }}
                                                  onClick={() => handleRemoveBox(index)}
                                                >
                                                  Remove
                                                </button>
                                              )}
                                            </div>


                                          </div>
                                        </section>
                                      </div>
                                    </div>
                                  ))}
                                  {/* <div class="col-12 col-md-3 mb-3">
                                    <label for="" class="form-label">Actual Weight:</label>
                                    <div class="input-group">
                                      <input type="text" class="form-control" placeholder="Enter Weight" name="weight" onChange={(e) => handleChange(e)} value={state.weight} />
                                      <span class="input-group-text">KG</span>
                                    </div>
                                  </div> */}
                                  <div class="col-12 col-md-3 mb-3">
                                    <label for="" class="form-label">Shipment Value:</label>
                                    <div class="input-group">
                                      <input type="number" class="form-control" placeholder="Enter Value" name="shipment_value" onChange={(e) => handleChange(e)} value={state.shipment_value} />
                                      {/* <span class="input-group-text">KG</span> */}
                                    </div>
                                  </div>
                                  {/* <div class="col-12 col-md-6 mb-3">
                                    <label for="" class="form-label">Dimensions:</label>
                                    <div class="row">
                                      <div class="col-12 col-md-4 mb-3">
                                        <div class="input-group">
                                          <input type="text" class="form-control" placeholder="H" onChange={(e) => handleChange(e)} name="height" value={state.height} />
                                          <span class="input-group-text">CM</span>
                                        </div>
                                      </div>
                                      <div class="col-12 col-md-4 mb-3">
                                        <div class="input-group">
                                          <input type="text" class="form-control" placeholder="W" onChange={(e) => handleChange(e)} name="width" value={state.width} />
                                          <span class="input-group-text">CM</span>
                                        </div>
                                      </div>
                                      <div class="col-12 col-md-4 mb-3">
                                        <div class="input-group">
                                          <input type="text" class="form-control" placeholder="L" onChange={(e) => handleChange(e)} name="length" value={state.length} />
                                          <span class="input-group-text">CM</span>
                                        </div>
                                      </div>
                                    </div>
                                  </div> */}
                                  <div class="col-12 col-md-6 mb-3">
                                    <label for="" class="form-label">Mode:</label>
                                    <div>
                                      <div class="form-check form-check-inline">
                                        <input class="form-check-input" type="radio" name="cod" id="inlineRadio2" value="option2" onChange={(e) => payment_mode(e)} checked={paymentmode.mode == 2} />
                                        <label class="form-check-label" for="inlineRadio1">Cash On Delivery</label>
                                      </div>
                                      <div class="form-check form-check-inline">
                                        <input class="form-check-input" type="radio" name="prepaid" id="inlineRadio1" value="option1" onChange={(e) => payment_mode(e)} checked={paymentmode.mode == 1} />
                                        <label class="form-check-label" for="inlineRadio2">Prepaid</label>
                                      </div>
                                    </div>
                                  </div>

                                  <div class="col-12 col-md-6 mb-3">
                                    <label for="" class="form-label">ROV/Insurance:</label>
                                    <div>
                                      <div class="form-check form-check-inline">
                                        <input class="form-check-input" type="radio" name="owner_risk" id="inlineRadio1" value="option1" onChange={(e) => risk_mode(e)} checked={riskstate.risk == 1} />
                                        <label class="form-check-label" for="inlineRadio1">OR (Owner Risk)</label><br />
                                        {/* Max Cover: Only COF (Cretificate of Fact) */}
                                      </div>
                                      <div class="form-check form-check-inline">
                                        <input class="form-check-input" type="radio" name="carrier_risk" id="inlineRadio1" value="option1" onChange={(e) => risk_mode(e)} checked={riskstate.risk == 2} />
                                        <label class="form-check-label" for="inlineRadio1">CR (Carrier Risk)</label>
                                        {/* Max Cover: 100% of invoice value,less processing charges */}
                                      </div>
                                    </div>
                                  </div>
                                  {paymentmode.mode == 2 ?
                                    <div class="row">
                                      <div class="col-12 col-md-5 mb-3">
                                        <input type="text" class="form-control" id="" placeholder="Enter COD amount" name="cod_amount"
                                          onChange={(e) => codvalueChange(e)} value={codvalue.cod_amount} />
                                      </div>
                                    </div> : ""}
                                  {/* <div class="col-12 col-md-6 mb-3">
                                        <label for="" class="form-label">Shipment Value (₹):</label>
                                        <div class="input-group">
                                            <span class="input-group-text">₹</span>
                                            <input type="text" class="form-control" placeholder="Enter the shipment values" value="0.00" />
                                        </div>
                                    </div> */}
                                  {/* <div class="col-12 col-md-6 mb-3">
                                        <label for="" class="form-label">Shipping Dangerous Goods?:</label>
                                        <div>
                                            <div class="form-check form-check-inline">
                                              <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio1" value="option1" />
                                              <label class="form-check-label" for="inlineRadio1">Yes</label>
                                            </div>
                                            <div class="form-check form-check-inline">
                                              <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio2" value="option2" />
                                              <label class="form-check-label" for="inlineRadio2">No</label>
                                            </div>
                                        </div>
                                    </div> */}
                                  <div class="row mt-4">
                                    <div class="col-12 col-md-2 mb-3">
                                      <div class="form-check form-check-inline">
                                        <input class="form-check-input" type="radio" name="self_pickup" id="inlineRadio1" value="option1" onChange={(e) => self_mode(e)} checked={selfstate.self == 1} />
                                        <label class="form-check-label" for="inlineRadio1">Pickup <a href="#" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" class="text-muted"><i class="fa fa-question-circle-o" aria-hidden="true"></i></a></label>
                                      </div>
                                    </div>
                                    <div class="col-12 col-md-2 mb-3">
                                      <div class="form-check form-check-inline">
                                        <input class="form-check-input" type="radio" name="self_drop" id="inlineRadio1" value="option1" onChange={(e) => self_mode(e)} checked={selfstate.self == 2} />
                                        <label class="form-check-label" for="inlineRadio1">Self Drop<a href="#" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" class="text-muted"><i class="fa fa-question-circle-o" aria-hidden="true"></i></a></label>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                {/* <h6>Volumetric Weight <span class="ms-5">{volume} Kg</span></h6>

                                <h6 class="mb-3 mt-3">Applicable Weight  <span className='ms-5'>{volume && state.weight !== "" ?
                                  (parseFloat(volume) > parseFloat(state.weight) ? volume : state.weight) + " Kg" :
                                  "0.00 Kg"
                                }</span> </h6> */}

                                <div>
                                  <a onClick={() => get_b2b_list()} class="btn btn-primary me-2">Calculate</a>
                                  <a onClick={() => reset()} class="btn btn-outline-primary">Reset</a>
                                </div>
                              </section>
                            </div>
                          </div>
                        </div>}
                      {/* <div class="col-12 col-md-6">
            <h5 class="bg-primary text-white p-2 text-center">Pricing Plans</h5>
            <div class="bg-white p-2">
            
                <div class="table-responsive">
                    <table class="table table-bordered table-hover table-sm">
                        <thead class="bg-table">
                            <tr>
                            <th>Zones</th>
                            <th>0-0.1 KG</th>
                            <th>0.1-0.2 KG</th>
                            <th>0.2-0.3 KG</th>
                            <th>0.3-0.4 KG</th>
                            <th>Additional 0.5 KG</th>
                            <th>Commission (%)</th>

                          </tr>
                        </thead>
                        <tbody>
                         <tr>
                         <td>Local Zone</td>
                         <td>10</td>
                         <td>20</td>
                         <td>30</td>
                         <td>40</td>
                         <td>100</td>
                         <td>10</td>

                         </tr>
                         <tr>
                         <td>State Zone</td>
                         <td>30</td>
                         <td>40</td>
                         <td>50</td>
                         <td>60</td>
                         <td>80</td>
                         <td>10</td>
                         </tr>
                         <tr>
                         <td>ROI Zone</td>
                          <td>30</td>
                         <td>40</td>
                         <td>50</td>
                         <td>60</td>
                         <td>80</td>
                         <td>10</td>
                         </tr>
                         <tr>
                         <td>Metro To Metro Zone</td>
                          <td>30</td>
                         <td>40</td>
                         <td>50</td>
                         <td>60</td>
                         <td>80</td>
                         <td>10</td>
                         </tr>
                         <tr>
                         <td>Special Zone</td>
                          <td>30</td>
                         <td>40</td>
                         <td>50</td>
                         <td>60</td>
                         <td>80</td>
                         <td>10</td>
                         </tr>
                        <tr>
                        <h4>Delhivery</h4>
                        </tr>
                        </tbody>
                      </table>
                </div>
                <div class="d-flex justify-content-end">
                    <a href="#" class="btn btn-outline-secondary"><i class="bi bi-file-excel"></i> Download Pricing Chart</a>
                </div>
            </div>
        </div> */}
                    </div>



                  </div>
                  <div class=" pt-3">
                    <div class="row">
                      <div class="col-12 col-md-12">
                        <div class="row">
                          <div class="col-12 col-md">
                            {/* <h4>Select Courier Partner</h4> */}
                          </div>
                          <div class="col-12 col-md-4 text-end">
                            <small> Pickup From
                              <strong>{state.from_postal_code}</strong> |
                              Deliver To
                              <strong>{state.to_postal_code}</strong></small>
                          </div>
                        </div>
                        {/* <div class="row pt-3 mb-3">
                      <div class="col-12 col-md">
                          <ul class="nav nav-pills">
                              <li class="nav-item">
                              <a class="nav-link active" href="#">All</a>
                              </li>
                              <li class="nav-item">
                              <a class="nav-link" href="#">Air</a>
                              </li>
                          </ul>
                      </div>
                      <div class="col-12 col-md-4">
                          <select class="form-select form-select-sm" onChange={(e)=>sort_by(e)}>
                          <option>Sort By: Recommended</option>
                          <option value="low">Sort By: Cheapest</option>
                          </select>
                      </div>
                  </div> */}
                        <section class="package_box">
                          {loadingstate.loading ?
                            <div style={{
                              width: "100%", display: "flex",
                              justifyContent: "center"
                            }}>


                              <ReactLoading type={"spin"} color={"#0d6efd"} height={300} width={89} />
                            </div>
                            : ""}
                          <h3>
                            {errorstate.message}</h3>
                          <div class="card mb-3">
                            {(statepackage.length != 0) ?
                              statepackage.map((item, index) =>
                                <div class="card-body ">
                                  <div className='card '>
                                    <div className='card-body'>
                                      <div class="row">
                                        <div class="col-12 col-md">
                                          <div class="d-flex">
                                            <div class="p-2">
                                              {item.carrier_id == "2433170006" ? "" :
                                                <figure >
                                                  <img src={`https://cdn.shiprath.com/images/${item.carrierImage}`} height="30px" />
                                                </figure>
                                              }
                                            </div>
                                            <div class="ps-2 ">
                                              <h4>{item.service_provider}</h4>
                                            </div>
                                          </div>
                                        </div>
                                        <div class="col-12 col-md-4 text-end">
                                          <h6>{item.product_type_name ? item.product_type_name : ""}
                                            {/* | Min-weight: 0.5 kg */}
                                          </h6>
                                        </div>
                                      </div>

                                      <div class="row">
                                        {/* <div class="col-12 col-md-2">
                                  <div class="card rating_card">
                                    <div class="card-body">
                                      <h5>Rating 3.5</h5>
                                      <div class="text-warning">
                                          <i class="material-icons-outlined">star</i>
                                          <i class="material-icons-outlined">star</i>
                                          <i class="material-icons-outlined">star</i>
                                          <i class="material-icons-outlined">star_half</i>
                                          <i class="material-icons-outlined">star_border</i>
                                      </div>
                                    </div>
                                  </div>
                              </div> */}
                                        {/* <div class="col-12 col-md pt-3">
                                  <h5>Expected Pickup</h5>
                                  <small>-----</small>
                              </div> */}
                                        <div class="col-12 col-md pt-3">
                                          <h5>Estimated Delivery</h5>
                                          <small>{item.delivery_days ? `${item.delivery_days} days` : ""} </small>
                                        </div>
                                        <div class="col-12 col-md pt-3">
                                          <h5>Weight</h5>
                                          <small>{item.new_weight?item.new_weight.toFixed(2):volume && state.weight !== "" ?
                                  (parseFloat(volume) > parseFloat(state.weight) ? volume : state.weight) + "" :
                                  "0.00"} Kg</small>
                                        </div>
                                        <div class="col-12 col-md pt-3">
                                          <h3>{dimensionState.companyDetail.map((subscriber) => (
                                            <>{subscriber.set_currency}</>
                                          ))}{parseFloat(Number(item.total_charges) + Number(item.commission_charge)).toFixed(2)}</h3>
                                          {active == 1 ? <button
                                            className="btn  btn-sm  p-0"
                                            onClick={() => setShowBreakdown(!showBreakdown)}
                                          >
                                            {showBreakdown ? 'Hide details' : 'Show breakdown'}
                                          </button> : ""}
                                        </div>
                                        {showBreakdown && item.charge_breakdown && (
                                          <div className="col-12 mt-3">
                                            <div className="card">
                                              <div className="card-body p-3">
                                                <h6 className="mb-3">Rate Breakdown</h6>
                                                <div className="row">
                                                  {Object.entries(item.charge_breakdown).map(([key, value]) => (
                                                    <div className="col-6 col-md-4 mb-2" key={key}>
                                                      <div className="d-flex justify-content-between">
                                                        <span className="text-capitalize">
                                                          {key.replace(/_/g, ' ')}:
                                                        </span>
                                                        <span>₹{value}</span>
                                                      </div>
                                                    </div>
                                                  ))}
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        )}

                                      </div>
                                    </div>

                                  </div>
                                </div>

                              ) : ""}
                          </div>



                        </section>
                      </div>
                    </div>
                  </div>
                </section>



              </div>
            </div>

          </div>
          <Footer />
        </div></div>
    </div>
  )
}

export default Rate_calculator
